export default __webpack_public_path__ + "static/media/StarPage2.bb5423ad.txt";